import React, { ComponentProps, FC, ReactNode } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';
import { media } from '@clds/style-utils';
import Checkbox from '@clds/checkbox';
import { Icon, Icons } from '@cld/icon';

type CheckboxProps = Pick<ComponentProps<typeof Checkbox>, 'onChange' | 'value'>;
const { spacing } = globalTheme;

export interface CheckboxRecordProps extends CheckboxProps {
  /** Number to display in parentheses. */
  count?: number;
  /** Children to display next to checkbox */
  children: ReactNode;
  id: string;
  value?: boolean;
  icon?: Icons;
}

export const StyledCheckbox = styled(Checkbox)`
  margin-right: ${spacing.xs};
  flex-shrink: 0;
`;

const Count = styled.span`
  ${typography.xs.lowContrast};
  white-space: pre;
`;

export const Root = styled.div`
  ${typography.xs.regular};
  display: flex;
  white-space: nowrap;
  align-items: end;

  @media ${media.phone()} {
    white-space: normal;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`;

const StyledIcon = styled(Icon)`
  margin-right: ${spacing.xs};
`;

export const CheckboxRecord: FC<React.PropsWithChildren<CheckboxRecordProps>> = ({ onChange, id, value, children, count, icon }) => (
  <Root>
    <CheckboxWrapper>
      <StyledCheckbox onChange={onChange} id={id} value={value} />
      {icon && <StyledIcon size="md" name={icon} />}
    </CheckboxWrapper>
    <label htmlFor={id}>
      {children}
      {count !== undefined && <Count> ({count})</Count>}
    </label>
  </Root>
);
